var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTotal = function SvgTotal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    width: 60,
    height: 60,
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 19.4 19.4 25 12.5 25S0 19.4 0 12.5 5.6 0 12.5 0 25 5.6 25 12.5zm35 0C60 19.4 54.4 25 47.5 25S35 19.4 35 12.5 40.6 0 47.5 0 60 5.6 60 12.5zm0 35C60 54.4 54.4 60 47.5 60S35 54.4 35 47.5 40.6 35 47.5 35 60 40.6 60 47.5zm-35 0C25 54.4 19.4 60 12.5 60S0 54.4 0 47.5 5.6 35 12.5 35 25 40.6 25 47.5z"
  })));
};
export default SvgTotal;